import React from 'react';
import { ArrowUpRight } from 'lucide-react';

import { LINKEDIN_NEWSLETTER_HREF, NEWSLETTER_CARD } from '../../constants';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';

/**
 * The newsletter ("The Resale Rundown") lives on LinkedIn, so this card is copy
 * plus one tracked outbound link — same shape as NewsroomBand. There is no
 * in-page confirmation because the portal cannot know whether the visitor
 * completed the subscription on LinkedIn.
 */
const NewsletterCard: React.FC = () => (
  <div className={styles.card}>
    <span className={styles.kicker}>{NEWSLETTER_CARD.kicker}</span>
    <h2 className={styles.title}>{NEWSLETTER_CARD.title}</h2>
    <p className={styles.body}>{NEWSLETTER_CARD.body}</p>

    <a
      className={styles.cta}
      href={LINKEDIN_NEWSLETTER_HREF}
      onClick={() =>
        track('newsletter_linkedin_clicked', { location: 'contact_page' })
      }
      target="_blank"
      rel="noopener noreferrer"
    >
      {NEWSLETTER_CARD.ctaLabel}
      <ArrowUpRight size={16} strokeWidth={1.8} aria-hidden="true" />
    </a>
  </div>
);

export default NewsletterCard;
